export function CreditsPage() {
  const libs = [
    { name: 'React', url: 'https://github.com/facebook/react', license: 'MIT', desc: 'UI framework' },
    { name: 'Lucide', url: 'https://github.com/lucide-icons/lucide', license: 'ISC', desc: 'Icon library' },
    { name: 'Parcel', url: 'https://github.com/parcel-bundler/parcel', license: 'MIT', desc: 'Build tool' },
    { name: 'esbuild', url: 'https://github.com/evanw/esbuild', license: 'MIT', desc: 'JavaScript bundler' },
    { name: 'TypeScript', url: 'https://github.com/microsoft/TypeScript', license: 'Apache 2.0', desc: 'Language' },
  ];

  return (
    <div
      style={{
        minHeight: '100vh',
        minHeight: '100dvh',
        background: 'linear-gradient(155deg, #07070d 0%, #0b0b16 35%, #080812 100%)',
        fontFamily: '"DM Sans", sans-serif',
        color: '#e8e4dc',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        overflowX: 'hidden',
        padding: 'clamp(24px, 5vh, 40px) 24px',
      }}
    >
      {/* Ambient orbs */}
      <div
        style={{
          position: 'fixed',
          top: '15%',
          left: '8%',
          width: 500,
          height: 500,
          background: 'radial-gradient(circle, rgba(255,107,43,.025) 0%, transparent 60%)',
          pointerEvents: 'none',
          animation: 'drift 25s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'fixed',
          bottom: '10%',
          right: '5%',
          width: 400,
          height: 400,
          background: 'radial-gradient(circle, rgba(78,205,196,.02) 0%, transparent 60%)',
          pointerEvents: 'none',
          animation: 'drift2 30s ease-in-out infinite',
        }}
      />

      <div style={{ maxWidth: 600, width: '100%', zIndex: 1 }}>
        <a
          href="/"
          style={{
            fontFamily: '"Space Mono", monospace',
            fontSize: 12,
            color: '#555',
            textDecoration: 'none',
            letterSpacing: 1,
          }}
        >
          &larr; back
        </a>

        <h1
          style={{
            fontFamily: '"Space Mono", monospace',
            fontSize: 'clamp(20px, 4vw, 28px)',
            fontWeight: 700,
            letterSpacing: 2,
            margin: '32px 0 32px',
          }}
        >
          credits
        </h1>

        <div style={{ lineHeight: 1.8, color: '#aaa', fontSize: 14 }}>
          <section style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Built by</h2>
            <p style={{ margin: 0 }}>
              <a
                href="https://leftjoinstudio.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#ff6b2b', textDecoration: 'none' }}
              >
                Left Join Studio, Inc.
              </a>
            </p>
          </section>

          <section style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Hosted on</h2>
            <p style={{ margin: 0 }}>
              <a
                href="https://workers.cloudflare.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#ff6b2b', textDecoration: 'none' }}
              >
                Cloudflare Workers
              </a>{' '}
              with{' '}
              <a
                href="https://developers.cloudflare.com/durable-objects/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#ff6b2b', textDecoration: 'none' }}
              >
                Durable Objects
              </a>
            </p>
          </section>

          <section style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 12 }}>Open source</h2>
            <p style={{ margin: '0 0 16px', color: '#888' }}>
              Pulse is built with these open source projects.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {libs.map((lib) => (
                <div
                  key={lib.name}
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 8,
                    padding: '8px 12px',
                    background: 'rgba(255,255,255,.02)',
                    border: '1px solid rgba(255,255,255,.05)',
                    borderRadius: 6,
                  }}
                >
                  <a
                    href={lib.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      fontFamily: '"Space Mono", monospace',
                      fontSize: 13,
                      color: '#e8e4dc',
                      textDecoration: 'none',
                      fontWeight: 600,
                    }}
                  >
                    {lib.name}
                  </a>
                  <span style={{ fontSize: 12, color: '#555' }}>{lib.desc}</span>
                  <span style={{ marginLeft: 'auto', fontFamily: '"Space Mono", monospace', fontSize: 11, color: '#444' }}>
                    {lib.license}
                  </span>
                </div>
              ))}
            </div>
          </section>

          <section style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Typography</h2>
            <p style={{ margin: 0 }}>
              <a
                href="https://fonts.google.com/specimen/Space+Mono"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#ff6b2b', textDecoration: 'none' }}
              >
                Space Mono
              </a>
              {' '}and{' '}
              <a
                href="https://fonts.google.com/specimen/DM+Sans"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#ff6b2b', textDecoration: 'none' }}
              >
                DM Sans
              </a>
              {' '}via Google Fonts.
            </p>
          </section>

          <p style={{ margin: '32px 0 0', color: '#555', fontSize: 12 }}>
            See also: <a href="/terms" style={{ color: '#ff6b2b', textDecoration: 'none' }}>terms of service</a> · <a href="/privacy" style={{ color: '#ff6b2b', textDecoration: 'none' }}>privacy policy</a>
          </p>
        </div>
      </div>
    </div>
  );
}
